import SectionSummaryBuildingInfo from './SectionSummaryBuildingInfo';
import SectionSummaryCoverageLimitsCommercial from './SectionSummaryCoverageLimitsCommercial';
import SectionSummaryCoverageLimitsPersonal from './SectionSummaryCoverageLimitsPersonal';
import SectionSummaryDisclosures from './SectionSummaryDisclosures';
import SectionSummaryDisqualifiers from './SectionSummaryDisqualifiers';
import SectionSummaryDwellingInfo from './SectionSummaryDwellingInfo';
import SectionSummaryInceptionDate from './SectionSummaryInceptionDate';
import SectionSummaryInsuredInfo from './SectionSummaryInsuredInfo';
import SectionSummaryMortgagees from './SectionSummaryMortgagees';
import SectionSummaryPerils from './SectionSummaryPerils';
import SectionSummaryPropertyAddress from './SectionSummaryPropertyAddress';

export {
	SectionSummaryBuildingInfo,
	SectionSummaryCoverageLimitsCommercial,
	SectionSummaryCoverageLimitsPersonal,
	SectionSummaryDisclosures,
	SectionSummaryDisqualifiers,
	SectionSummaryDwellingInfo,
	SectionSummaryInceptionDate,
	SectionSummaryInsuredInfo,
	SectionSummaryMortgagees,
	SectionSummaryPerils,
	SectionSummaryPropertyAddress,
};